import { Trans } from 'react-i18next'
import styled from 'styled-components'
import config from '@/config'
import { Group } from '@/components/form'
import { colors, breakpoints } from '@/styles'
import { ParagraphSmall } from '@/components/text'

const { WEB_URL } = config

const TermsWrapper = styled(Group)`
  padding: 0;
  margin: 16px 0 0;
  text-align: left;
  display: flex;
  justify-content: center;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    margin-top: 24px;
  }
`

const NewText = styled(ParagraphSmall)`
  color: ${colors.grey32};
`

const Link = styled.a`
  color: ${colors.link};
  text-decoration: underline;
  font-weight: 500;
`

const TermsAndPrivacyPolicyDiv = () => {
  return (
    <TermsWrapper>
      <NewText>
        <Trans i18nKey="b.auth.create.social_login_terms_and_conditions.text">
          By signing in with the services above, you confirm that you are over 13 years old and that
          you have read and agreed to liv.rent{`'`}s{' '}
          <Link href={`${WEB_URL}/terms`} target="_blank" rel="noopener noreferrer">
            Terms & Conditions
          </Link>{' '}
          and{' '}
          <Link href={`${WEB_URL}/privacy`} target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </Link>
          .
        </Trans>
      </NewText>
    </TermsWrapper>
  )
}

export default TermsAndPrivacyPolicyDiv
